// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","white":"#ffffff","medium-grey":"#9f9f9f","section":"_2kTAAIaHmabzG7xqtph3f6","sectionHalf":"_1VtvH-vnmzz-WIuctFYjw0","list":"_2wcCdvcyUcEmD0EpOhScv5","itemWrapper":"QuvRsC9t3OUQoVe1G7nM","tint":"_2AMZfMTX56OpeV-3RPzAwW","active":"_3zPlGA8NRJkjORanh7cEvL","details":"OmHLlKMo0GUCkDeKKDM6t","colorName":"_1SSze3vQl5gmneRaBsutyj","colorCode":"_2i9WcikLlfHHfg-MoJzuzm","clipboard":"_1rSEZbqVpA5Raey7vyz5Wy"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/Colors/Colors.css
// module id = 657
// module chunks = 0